import React, { useEffect, useState } from "react";
import { Table, Row, Col, Input, Alert } from "reactstrap";
import { FormGroup } from "components/common";
import { Page } from "components/common";
import { useTable } from "hooks";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { Button, Badge } from "reactstrap";
import { withDocumentRenderer } from "components";
import TimeOffDispatcher from "components/documents/timeoffs/TimeOffDispatcher";
import { useMakePaymentModal } from "services";
import { NotificationManager } from "react-notifications";
import { XeroClient } from "services";
import Select from "react-select";
import DatePicker from "react-datepicker"

const PrintAllHolidays = withDocumentRenderer({
  onDownload:
    ({ selectedOrganisation, client }) =>
      (getDocument) => {
        getDocument(
          {
            selectedOrganisation,
            client,
          },
          `accrued_all.pdf`
        );
      },
})(({ PrintDocument, DocumentRenderer, items, t }) => {
  return (
    < >
      <PrintDocument className="mr-2" compact={items.length === 1} label={t("Print All")} />
      <DocumentRenderer component={TimeOffDispatcher} items={items} />
    </>
  )
});

const DownloadAll = withDocumentRenderer({
  onDownload:
    ({ selectedOrganisation, client }) =>
      (getDocument) => {
        getDocument(
          {
            selectedOrganisation,
            client,
          },
          `accrued_all.pdf`
        );
      },
})(({ DownloadDocument, DocumentRenderer, items, t }) => {
  return (
    < >
      <DownloadDocument className="" compact={items.length === 1} label={t("Download PDF")} />
      <DocumentRenderer component={TimeOffDispatcher} items={items} />
    </>
  )
});


export const Accrued = ({ selectedOrganisation, client, url = "employee_holidays/accrued", t, payroll }) => {
  const { TableContainer, data, PayrollTableDataFetch, refreshData } = useTable({
    url,
  });

  const [settings, setSettings] = useState();
  const [accounts, setAccounts] = useState([]);
  const [encahseData, setEncahseData] = useState({ pay_via_payslips: false, num_days: 0 })
  const [paymentData, setPaymentData] = useState(null)
  const [selectedAccrued, setSelectedAccrued] = useState(null)

  const [expanded, setExpanded] = useState({});
  const [ setModalOpen, toggle, MainModal ] = useMakePaymentModal(false)
  const [ setPaymentModalOpen, paymentToggle,  PaymentModal ] = useMakePaymentModal(false)

  const xero = XeroClient()

  useEffect(async () => {
    const [s, c_accounts] = await Promise.all([
      payroll.get(`/settings/1/public`).get("data"),
      xero.get("accounts", { params: { raw: `Status="ACTIVE" AND TYPE="BANK"` }, }).get("data").map((el) => ({
        label: `${el.Name}`,
        value: el.AccountID,
      }))
    ])

    setAccounts(c_accounts)
    setSettings(s);
  }, [])

  const handleNumberChange = (event, name, setState) => {
    let { value, min, max } = event.target;
    value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const EncahseHolidays = (data) => {
    data = { ...data, employee: selectedAccrued.employee }
    payroll.post(`employee_holidays/${selectedAccrued.employee}/encash_accrued`, data).then((resp) => {
      NotificationManager.success(t("Created successfully"));
      toggle()
      refreshData()

    }).catch((err) => {
      NotificationManager.error(t("Unexpected Error Happened"));
    })
  }

  const makePayment = (data) => {
    xero.post(`payments`, data).then((resp) => {
      NotificationManager.success(t("Paid successfully"));
      paymentToggle()
      refreshData()
    }).catch((err) => {
      NotificationManager.error(t("Unexpected Error Happened"));
    })
  }

  const OnAccruedClick = (selectedAccrued_) => {
    setSelectedAccrued(selectedAccrued_)
    if (selectedAccrued_.encashed_leaves) {
      const encashed_leaves = selectedAccrued_.encashed_leaves
      setEncahseData({ pay_via_payslips: encashed_leaves.pay_via_payslips, num_days: encashed_leaves.num_days })
    }
    toggle()
  }
  const OnPayClick = (selectedAccrued_) => {
    setSelectedAccrued(selectedAccrued_)
    setPaymentData({ 
      Amount: selectedAccrued_?.encashed_leaves?.amount, 
      Invoice:{InvoiceID:selectedAccrued_?.encashed_leaves?.xero_invoice_id},
      Account:{AccountID:settings.credit_account}
    })
    paymentToggle()
  }

  

  return (
    <>
      {data &&
        <Page className="inv-table">
          <br />
          {data.results &&
            <div className="row px-1" style={{ marginTop: "-2rem" }}>
              <div className="col-12 justify-content-end d-flex">
                <PrintAllHolidays
                  selectedOrganisation={selectedOrganisation}
                  items={data.results}
                  client={client}
                  t={t}
                />
                <DownloadAll
                  selectedOrganisation={selectedOrganisation}
                  items={data.results}
                  client={client}
                  t={t}
                />
              </div>
            </div>
          }
          <br />
          <hr />
          <TableContainer>
            {
              data.results &&
              <>
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th className="text-left">
                        <Trans>Employee</Trans>
                      </th>
                      <th>
                        <Trans>Expand Holidays</Trans>
                      </th>
                      <th>
                        <Trans>Opening</Trans>
                      </th>
                      <th>
                        <Trans>Earned</Trans>
                      </th>
                      <th>
                        <Trans>Total Holidays</Trans>
                      </th>
                      <th>
                        <Trans>Total Deductible</Trans>
                      </th>
                      <th>
                        <Trans>Encashed</Trans>
                      </th>
                      <th>
                        <Trans>Balance</Trans>
                      </th>
                      <th>
                        <Trans>Balance in cash</Trans>
                      </th>
                      <th>
                        <Trans>Actions</Trans>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.results.map((i) => (
                      <React.Fragment key={i.employee}>
                        <tr className="print-row" id={i.employee}>
                          <td className="text-left">
                            <Link to={`/payroll/employees/${i.employee}`}>
                              {i.employee__full_name}
                            </Link>
                          </td>
                          <td>
                            {i.approved_holidays.length ? (
                              <Button
                                className="d-print-none"
                                size="sm"
                                color="link"
                                onClick={() =>
                                  setExpanded((v) => ({
                                    ...v,
                                    [i.employee]: !v[i.employee],
                                  }))
                                }
                              >
                                <span
                                  className={
                                    expanded[i.employee] ? "fa fa-minus" : "fa fa-plus"
                                  }
                                />
                              </Button>
                            ) : null}
                          </td>
                          <td>{i.opening_balance}</td>
                          <td>{i.accrued_until_today}</td>
                          <td>{i.total_holidays_taken}</td>
                          <td>{i.total_unpaid_holidays}</td>
                          <td>{i.paid_encashed_leaves}</td>
                          <td>{i.current_balance}</td>
                          <td>{i.current_balance > 1 ? (parseFloat(i.current_balance) * parseFloat(i.daily_salary)).toFixed(2) : 0}</td>
                          <td>
                            <DownloadAll
                              selectedOrganisation={selectedOrganisation}
                              items={[i]}
                              client={client}
                              t={t}
                            />
                            {i.balance > 1 && <button className="btn btn-primary btn-sm py-0" onClick={() => OnAccruedClick(i)}>{i.encashed_leaves ? t("Edit") : t("Encash")}</button>}
                            {i.encashed_leaves && !i.encashed_leaves.pay_via_payslips && <button className="btn btn-primary btn-sm py-0" onClick={() => OnPayClick(i) }>Pay</button>}
                          </td>
                        </tr>
                        {i.approved_holidays.length > 0 && (
                          <tr
                            style={
                              expanded[i.employee]
                                ? { display: "table-row" }
                                : { display: "none" }
                            }
                            className="d-print-table-row print-row"
                            id={i.employee}
                          >
                            <td colSpan="8">
                              <Table size="sm">
                                <thead>
                                  <tr>
                                    <th>
                                      <Trans>Start</Trans>
                                    </th>
                                    <th>
                                      <Trans>End</Trans>
                                    </th>
                                    <th>
                                      <Trans>Type</Trans>
                                    </th>
                                    <th>
                                      <Trans>Reason</Trans>
                                    </th>
                                    <th>
                                      <Trans>Replacement</Trans>
                                    </th>
                                    <th>
                                      <Trans>Deductible</Trans>
                                    </th>
                                    <th>
                                      <Trans>Non-deductible</Trans>
                                    </th>
                                    <th>
                                      <Trans>Paid</Trans>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {i.approved_holidays.map((j) => (
                                    <tr key={j.id}>
                                      <td>
                                        {j.starting} <Trans>{j.starting_time}</Trans>
                                      </td>
                                      <td>
                                        {j.ending} <Trans>{j.ending_time}</Trans>
                                      </td>
                                      <td>{j.type}</td>
                                      <td>{j.reason || "-"}</td>
                                      <td>{j.replacement_employee__full_name || "-"}</td>
                                      <td>
                                        {j.is_deductable ? j.total_days : <span className="fa fa-times-circle text-danger" />}
                                      </td>
                                      <td>
                                        {!j.is_deductable ? j.total_days : <span className="fa fa-times-circle text-danger" />}
                                      </td>
                                      <td>{j.paid ? <span className="fa fa-check-circle text-success" /> : <span className="fa fa-times-circle text-danger" />}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
                <div className="hint px-2 text-right">
                  <small className="text-muted">
                    <Trans>Values are in days</Trans>
                  </small>
                </div>
              </>
            }
          </TableContainer>
          <PayrollTableDataFetch />
        </Page>

      }
      <MainModal
        title={t('Leaves Encashment Confirmation')}
        action={t("Save")}
        callback={() => EncahseHolidays(encahseData, selectedAccrued)}
      >
        <Alert color="warning"> <Trans>You're about to encash the leaves of the employee </Trans> (<strong>{selectedAccrued?.employee__full_name}</strong>)</Alert>

        <Row className="mt-3">
          <Col className="col-12">
            <FormGroup label={t("Number of holidays to encash")}>
              <Input
                type="number"
                max={selectedAccrued?.current_balance}
                min={0}
                name="num_days"
                value={encahseData.num_days || ''}
                onChange={(e) => { handleNumberChange(e, 'num_days', setEncahseData) }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mb-3 mt-2">
          <Col className="col-6">
            <small><strong><Trans>Available holidays</Trans>: {selectedAccrued?.current_balance}</strong></small>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="col-12">
            <FormGroup label={t("Equivalent amount of cash")}>
              <Input
                type="number"
                name="cash"
                disabled
                value={(parseFloat(encahseData.num_days)*parseFloat(selectedAccrued?.daily_salary)).toFixed(2) || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="my-3">
          <Col className="col">
            <FormGroup className="form-g-check px-1" >
              <div className="mx-3">
                <Input type="checkbox" checked={encahseData.pay_via_payslips} onChange={() => setEncahseData({ ...encahseData, pay_via_payslips: !encahseData.pay_via_payslips })} />
                <span className="ml-2" >
                  <Trans>Pay via Payslips</Trans>
                </span>
              </div>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col className="text-right">
            {
              selectedAccrued?.encashed_leaves?.xero_invoice_id && <a className="mx-1 link text-success" href={`/purchases/bills/view/${selectedAccrued?.encashed_leaves?.xero_invoice_id }`} target="_blank"><Trans>View Bill</Trans></a>
            }
          </Col>
        </Row>

      </MainModal>

      <PaymentModal
        title={t('Leaves Encashment Confirmation')}
        action={t("Save")}
        callback={() => makePayment(paymentData)}
      >
        <Alert color="warning"> <Trans>You're about to pay the leaves for the employee </Trans> (<strong>{selectedAccrued?.employee__full_name}</strong>)</Alert>

        <Row>
          <Col className="col-12 my-2">
            <FormGroup label={t("Amount")} >
              <Input type="number" name="amount" value={paymentData?.Amount || ''} disabled/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col className="col-12 my-2">
            <FormGroup label={t("Select a Bank Account")} >
              {accounts &&
                <Select placeholder={`${t("Select a bank account")}`} options={accounts} value={paymentData?.Account?.AccountID} onChange={(e) => setPaymentData({ ...paymentData, Account: {AccountID: e?.value} })} Isclearable={false} />}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col className="col-12 my-2">
            <FormGroup
              label={t("Payment Date")}
            >
              <DatePicker
                className="form-control"
                selected={paymentData?.Date}
                onChange={(v) => { setPaymentData({ ...paymentData, Date: v }) }}
                dateFormat='YYYY-MM-DD'
                placeholderText={t("Select Date")}
              />
            </FormGroup>
          </Col>
        </Row>
        {/* <Row>
          <Col className="col-12">
            <FormGroup
              label={t("Reference (Optional)")}
            >
              <Input
                type="text"
                name="reference"
                value={reference || ''}
                onChange={(e) => { setReference(e.target.value) }}
                placeholder={t("Reference (Optional)")}
              />
            </FormGroup>
          </Col>
        </Row> */}
      </PaymentModal>
    </>

  );
};

export default Accrued;